import { BubbleMenu, Editor } from '@tiptap/react'

import { ImageMenuOptions } from './ImageMenuOptions.js'

export const ImageMenu = ({ editor }: { editor: Editor }) => {
  return (
    <BubbleMenu
      pluginKey="image-bubble-menu"
      shouldShow={({ editor }) => {
        return editor.isActive('async-image')
      }}
      editor={editor}
      tippyOptions={{
        delay: 0,
        arrow: true,
        placement: 'bottom',
        moveTransition: 'transform 0.2s ease-out',
        appendTo: 'parent',
        offset: [0, 5],
        maxWidth: '100vw',
        /**
         *  The return type of this function is void | false, hence being impossible
         *  to enforce consistent return.
         */
        // eslint-disable-next-line consistent-return
        onHide(_) {
          /**
           * This callback prevents a bug in Safari where opening a dropdown in the
           * image options (e.g. size) would cause the component to hide prematurely and
           * the dropdown to appear in top-left corner of the screen.
           * There's still an issue where closing the popover while the dropdown is active
           * would cause the dropdown to flash to the top, but this is an edge case, and is caused
           * by the dropdown component being rendered in a portal, outside the popover component tree.
           */

          if (editor.isActive('async-image')) {
            return false
          }
        },
      }}
    >
      <ImageMenuOptions editor={editor} />
    </BubbleMenu>
  )
}
